import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const EverlanceBusinessIcon = ({
  width = '92',
  height = '92'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      width: width,
      height: height
    }}
    viewBox="0 0 92 92"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="46.0092"
      cy="27.9236"
      r="15.2162"
      fill="#31B59F"
      stroke="#31B59F"
      strokeWidth="0.981689"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.6571 36.4316C38.1075 36.7051 37.5131 36.1499 37.7486 35.583L45.4217 17.1051C45.6485 16.559 46.4224 16.5598 46.648 17.1065L54.2732 35.5808C54.5074 36.1484 53.9116 36.7023 53.3626 36.4274L46.0365 32.759L38.6571 36.4316Z"
      stroke="white"
      strokeWidth="0.625438"
      fill="#31B59F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46.0365 15.8193V32.7588L54.8003 37.0703L46.0365 15.8193Z"
      fill="white"
      stroke="white"
      strokeWidth="0.0893483"
    />
    <circle cx="46.009" cy="54.0033" r="5.34218" fill="#31B59F" />
    <path
      d="M41.9653 58.8618C44.2421 60.9692 47.7573 60.9692 50.034 58.8618C54.2385 60.5844 56.9848 64.6775 56.9848 69.2212V75.7315C50.1241 78.6771 42.367 78.74 35.4594 75.9062L35.0334 75.7315V69.2037C35.0334 64.6698 37.7715 60.5847 41.9653 58.8618Z"
      fill="#31B59F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.7619 59.8975C67.2568 59.8975 69.2793 57.875 69.2793 55.38C69.2793 52.8851 67.2568 50.8625 64.7619 50.8625C62.2669 50.8625 60.2444 52.8851 60.2444 55.38C60.2444 57.875 62.2669 59.8975 64.7619 59.8975ZM74.0433 73.7548V68.0904C74.0442 66.0767 73.0674 61.6014 68.1685 59.4865C66.1232 61.3777 63.118 61.1696 61.3469 59.4889C58.6312 60.5007 57.1625 62.4043 56.4303 63.8287C57.3752 65.6958 57.6854 66.9034 57.7571 69.1609C57.7571 69.7141 57.7612 70.1452 57.7654 70.5856C57.774 71.4956 57.783 72.4454 57.7571 74.5937C61.1132 75.6393 67.113 76.701 74.0433 73.7548Z"
      fill="#31B59F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.238 59.8975C24.743 59.8975 22.7205 57.875 22.7205 55.38C22.7205 52.8851 24.743 50.8625 27.238 50.8625C29.7329 50.8625 31.7554 52.8851 31.7554 55.38C31.7554 57.875 29.7329 59.8975 27.238 59.8975ZM17.9566 73.7548V68.0904C17.9557 66.0767 18.9325 61.6014 23.8315 59.4865C25.8767 61.3777 28.8819 61.1696 30.6531 59.4889C33.3687 60.5007 34.8375 62.4043 35.5696 63.8287C34.6247 65.6958 34.3145 66.9034 34.2429 69.1609C34.2429 69.7141 34.2388 70.1452 34.2346 70.5856C34.2259 71.4956 34.2169 72.4454 34.2429 74.5937C30.8867 75.6393 24.8869 76.701 17.9566 73.7548Z"
      fill="#31B59F"
    />
  </IconSvg>
)

export default EverlanceBusinessIcon
